import { actions, selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { TextureResolution } from '@sloyd/ui';
import { useMemo } from 'react';
import { setString } from 'shared-base';

export type TextureResolutionContainerProps = {};

export function TextureResolutionContainer(_props: TextureResolutionContainerProps) {
  const dispatch = useDispatch();
  const appState = useSelector(selectors.raw.$rawAppState);
  const settings = useSelector(selectors.raw.$rawSettings);
  const focusMode = useSelector(selectors.base.$focusMode);
  const { editMode } = appState;

  const callbacks = useMemo(
    () => ({
      onChange: (value: TextureResolution) => {
        setString('TEXTURE_RESOLUTION', value);
        dispatch(actions.settings.patch({ texturesResolution: value }));
      },
    }),
    []
  );

  if (editMode !== 'material' || focusMode !== 'existing') return null;

  return (
    <TextureResolution resolution={settings.texturesResolution} onChange={callbacks.onChange} />
  );
}

export default TextureResolutionContainer;
